import { useEffect, useRef } from 'react';
import { isDeepEqual } from '../utilities';
import { setCookie } from '../utils/cookieUtils';

export function usePersistDepositedData(depositedData, step) {
	const previousValues = useRef(depositedData);

	useEffect(() => {
		if (!isDeepEqual(previousValues.current, depositedData)) {
			previousValues.current = depositedData;

			setCookie(
				'_subscriptionDepositedData',
				JSON.stringify({
					step: step,
					depositedData: depositedData,
				}),
				1,
			);
		}
	});
}
